// extracted by mini-css-extract-plugin
export default {"button":"AccordionButton_button__0tZUK","caret":"AccordionButton_caret__jJosF"};